import * as React from "react";
import {useState} from "react";
import {Alert, Button, Col, Form, Row, Spinner} from "react-bootstrap";


function ComplaintForm() {
    const [isSent, setIsSent] = useState(false)
    const [error, setError] = useState(undefined)
    const [isLoading, setIsLoading] = useState(false)

    async function handleSubmit(event) {
        event.preventDefault()
        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData);

        try {
            setIsLoading(true)
            const response = await fetch("/api/email", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) {

                throw new Error("Request failed");
            }
            event.target.reset()
            setIsLoading(false)
            setIsSent(true)
            setError(undefined)
            setTimeout(() => {
                setIsSent(false);
            }, 2000);
        } catch (error) {
            console.error("Error:", error);
            setIsLoading(false)
            setIsSent(true)
            setError(error.toString())
        }
    }

    return <Form className="complaint-form" onSubmit={handleSubmit}>
        <fieldset disabled={isLoading}>
            <Row className="mb-3">
                <Col>
                    <Form.Group>
                        <Form.Label>Keresztnév</Form.Label>
                        <Form.Control
                            name="firstName"
                            type="text"
                            placeholder="Hogyan szólíthatunk?"
                        />
                    </Form.Group>
                </Col>

                <Col>
                    <Form.Group>
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            name="email"
                            type="email"
                            placeholder="E-mail címed"
                            pattern="^[A-Za-z0-9._%+-]+@company\.com$"
                            required
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Form.Group>
                    <Form.Label>Tárgy</Form.Label>
                    <Form.Control
                        name="subject"
                        type="text"
                        placeholder="Miben segíthetünk?"
                    />
                </Form.Group>
            </Row>
            <Row className="mb-3">
                <Form.Group>
                    <Form.Label>Üzenet</Form.Label>
                    <Form.Control
                        name="message"
                        as="textarea"
                        rows={3}
                        placeholder="Ide írd az üzeneted!"
                    />
                </Form.Group>
            </Row>
            <div className="text-center">
                <Button variant="primary" type="submit">
                    Elküldöm
                </Button>
            </div>
        </fieldset>
        <div className="text-center mt-3" hidden={!isLoading}>
            <Spinner animation="border" role="status"/>
        </div>
        <Alert className="mt-3" show={isSent} variant={error ? "danger" : "success"}>
            {error ?? "Elküldve!"}
        </Alert>
    </Form>;
}

export default ComplaintForm